/**
 * @fileoverview Error thrown by uploadToR2 when a direct-to-R2 PUT fails after every retry.
 */

/**
 * A direct-to-R2 PUT that failed after every retry. Operator copy only — the
 * message is never shown to users (see isPlumbingError); diagnostics are fields.
 */
export class UploadTransferError extends Error {
  readonly status: number
  readonly reason: 'network' | 'stalled' | 'aborted' | 'http'
  readonly attempts: number

  constructor(reason: UploadTransferError['reason'], status: number, attempts: number) {
    super('Upload transfer failed')
    this.name = 'UploadTransferError'
    this.reason = reason
    this.status = status
    this.attempts = attempts
  }
}

export function isUploadTransferError(err: unknown): err is UploadTransferError {
  return err instanceof UploadTransferError
}
